"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactDom = require("react-dom");
var _WindowContext = require("./WindowContext");
const Portal = _ref => {
  let {
    children
  } = _ref;
  const {
    window: targetWindow
  } = (0, _react.useContext)(_WindowContext.WindowContext);
  const targetDocument = !!targetWindow ? targetWindow.document : document;
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, targetDocument.body);
};
Portal.displayName = 'Portal';
var _default = exports.default = Portal;